import { render } from "./AssignementsSubmitted.vue?vue&type=template&id=47b6542b&scoped=true"
import script from "./AssignementsSubmitted.vue?vue&type=script&lang=js"
export * from "./AssignementsSubmitted.vue?vue&type=script&lang=js"

import "./AssignementsSubmitted.vue?vue&type=style&index=0&id=47b6542b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b6542b"]])

export default __exports__